import React from "react";
import CtaSection from "../../components/Common/CtaSection";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import Footer from "../../components/Layout/Footer";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import shapeImageUrl from "../../assets/images/shapes/cta-one-shape-1.png";

const PrivacyPolicyMain = () => {
  return (
    <React.Fragment>
      {/*Page Header*/}
      <SiteBreadcrumb
        pageTitle="Privacy Policy"
        parentCategory="Home"
        // pageCategory="Legal"
        pageName="Privacy Policy"
        breadcrumbsImg={bannerbg}
      />

      {/*Privacy Policy Section Start*/}
      <section className="privacy-policy-one">
        <div className="container">
          <div className="privacy-policy-content">
            {/* 1. Introduction */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">1. Introduction</h3>
              <p>
                Arch Elevators Pvt. Ltd. ("we," "us," "our," or "Company") is committed to protecting your privacy. 
                This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website 
                and use our services. Please read this Privacy Policy carefully. If you do not agree with our policies and practices, 
                please do not use our website or services.
              </p>
            </div>

            {/* 2. Information We Collect */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">2. Information We Collect</h3>
              <p>
                <strong>2.1 Information You Provide Directly:</strong>
              </p>
              <ul className="privacy-list">
                <li>Contact information (name, email, phone number, address)</li>
                <li>Business information (company name, designation, project details)</li>
                <li>Communication preferences and inquiry details</li>
                <li>Payment information (processed securely through payment gateways)</li>
                <li>Any other information you voluntarily provide in forms or communications</li>
              </ul>
              <p style={{ marginTop: "15px" }}>
                <strong>2.2 Information Collected Automatically:</strong>
              </p>
              <ul className="privacy-list">
                <li>Browser type and version</li>
                <li>IP address and device information</li>
                <li>Pages visited and time spent on our website</li>
                <li>Referring website or source</li>
                <li>Cookies and similar tracking technologies</li>
              </ul>
            </div>

            {/* 3. How We Use Your Information */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">3. How We Use Your Information</h3>
              <p>We use the information we collect for the following purposes:</p>
              <ul className="privacy-list">
                <li>To provide, maintain, and improve our products and services</li>
                <li>To respond to your inquiries and customer support requests</li>
                <li>To process transactions and send related information</li>
                <li>To send promotional emails, newsletters, and updates (with your consent)</li>
                <li>To conduct market research and analyze website usage trends</li>
                <li>To comply with legal obligations and regulations</li>
                <li>To protect against fraudulent or unauthorized activity</li>
                <li>To personalize your experience and improve our website</li>
              </ul>
            </div>

            {/* 4. Legal Basis for Processing */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">4. Legal Basis for Processing</h3>
              <p>
                We process your personal data based on the following legal grounds:
              </p>
              <ul className="privacy-list">
                <li>Your explicit consent</li>
                <li>Performance of a contract with you</li>
                <li>Compliance with legal obligations</li>
                <li>Protection of vital interests</li>
                <li>Our legitimate business interests</li>
              </ul>
            </div>

            {/* 5. Information Sharing and Disclosure */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">5. Information Sharing and Disclosure</h3>
              <p>
                We do not sell, trade, or rent your personal information to third parties. However, we may share your information in the following circumstances:
              </p>
              <ul className="privacy-list">
                <li><strong>Service Providers:</strong> Third-party vendors who assist in our operations (payment processors, hosting providers, email services)</li>
                <li><strong>Legal Compliance:</strong> When required by law, court order, or government request</li>
                <li><strong>Business Transfers:</strong> In case of merger, acquisition, or sale of assets</li>
                <li><strong>Your Consent:</strong> When you explicitly authorize us to share your information</li>
              </ul>
              <p style={{ marginTop: "15px" }}>
                All third-party service providers are contractually obligated to maintain the confidentiality of your information.
              </p>
            </div>

            {/* 6. Data Security */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">6. Data Security</h3>
              <p>
                We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, 
                alteration, disclosure, or destruction. These measures include:
              </p>
              <ul className="privacy-list">
                <li>SSL/TLS encryption for data transmission</li>
                <li>Secure server infrastructure and firewalls</li>
                <li>Access controls and authentication protocols</li>
                <li>Regular security audits and updates</li>
                <li>Employee confidentiality agreements</li>
              </ul>
              <p style={{ marginTop: "15px" }}>
                However, no method of transmission over the Internet is 100% secure. While we strive to protect your information, 
                we cannot guarantee absolute security.
              </p>
            </div>

            {/* 7. Cookies and Tracking Technologies */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">7. Cookies and Tracking Technologies</h3>
              <p>
                Our website uses cookies and similar tracking technologies to enhance your experience. Cookies are small files stored 
                on your device that help us:
              </p>
              <ul className="privacy-list">
                <li>Remember your preferences and login information</li>
                <li>Understand how you use our website</li>
                <li>Improve website functionality</li>
                <li>Deliver personalized content</li>
              </ul>
              <p style={{ marginTop: "15px" }}>
                You can control cookie settings through your browser. Disabling cookies may affect the functionality of our website.
              </p>
            </div>

            {/* 8. Third-Party Links */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">8. Third-Party Links</h3>
              <p>
                Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of 
                external websites. We encourage you to review the privacy policies of any third-party sites before providing your information.
              </p>
            </div>

            {/* 9. Data Retention */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">9. Data Retention</h3>
              <p>
                We retain your personal information for as long as necessary to provide our services and fulfill the purposes outlined 
                in this Privacy Policy. Generally, we retain data for:
              </p>
              <ul className="privacy-list">
                <li>Customer records: Duration of business relationship plus 7 years for compliance purposes</li>
                <li>Marketing preferences: Until you opt-out</li>
                <li>Website usage data: Up to 24 months</li>
                <li>Legal obligations: As required by applicable law</li>
              </ul>
              <p style={{ marginTop: "15px" }}>
                You can request deletion of your data at any time, subject to legal retention requirements.
              </p>
            </div>

            {/* 10. Your Rights and Choices */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">10. Your Rights and Choices</h3>
              <p>
                Depending on your location, you may have the following rights regarding your personal information:
              </p>
              <ul className="privacy-list">
                <li><strong>Right of Access:</strong> Request what personal data we hold about you</li>
                <li><strong>Right of Correction:</strong> Update or correct inaccurate information</li>
                <li><strong>Right of Deletion:</strong> Request deletion of your data (subject to legal obligations)</li>
                <li><strong>Right of Portability:</strong> Receive your data in a structured, machine-readable format</li>
                <li><strong>Right to Opt-Out:</strong> Unsubscribe from marketing communications</li>
                <li><strong>Right to Withdraw Consent:</strong> Withdraw previously given consent at any time</li>
              </ul>
              <p style={{ marginTop: "15px" }}>
                To exercise any of these rights, please contact us at info@archelevators.com.
              </p>
            </div>

            {/* 11. Children's Privacy */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">11. Children's Privacy</h3>
              <p>
                Our website and services are not intended for individuals under 18 years of age. We do not knowingly collect personal 
                information from children. If we become aware that a child has provided us with personal information, we will take steps 
                to delete such information and terminate the child's account. Parents or guardians who believe their child has provided 
                information to us should contact us immediately.
              </p>
            </div>

            {/* 12. International Data Transfers */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">12. International Data Transfers</h3>
              <p>
                Your information may be transferred to, stored in, and processed in countries other than your country of residence. 
                These countries may have data protection laws that differ from your home country. By using our website and services, 
                you consent to the transfer of your information to countries outside your country of residence.
              </p>
            </div>

            {/* 13. Marketing Communications */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">13. Marketing Communications</h3>
              <p>
                We may send you promotional emails, newsletters, and marketing materials based on your preferences. You can opt-out of 
                these communications at any time by:
              </p>
              <ul className="privacy-list">
                <li>Clicking the "Unsubscribe" link in any email we send</li>
                <li>Updating your communication preferences in your account settings</li>
                <li>Contacting us directly at info@archelevators.com</li>
              </ul>
            </div>

            {/* 14. California Privacy Rights (CCPA) */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">14. California Privacy Rights (CCPA)</h3>
              <p>
                If you are a California resident, you may have additional rights under the California Consumer Privacy Act (CCPA), including:
              </p>
              <ul className="privacy-list">
                <li>Right to know what personal information is collected</li>
                <li>Right to know whether personal information is sold or disclosed</li>
                <li>Right to delete personal information collected</li>
                <li>Right to opt-out of the sale or sharing of personal information</li>
                <li>Right to non-discrimination for exercising your CCPA rights</li>
              </ul>
            </div>

            {/* 15. Changes to This Privacy Policy */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">15. Changes to This Privacy Policy</h3>
              <p>
                We may update this Privacy Policy from time to time to reflect changes in our practices, technology, or legal requirements. 
                We will notify you of any significant changes by updating the "Last Updated" date below. Your continued use of our website 
                and services after any changes constitutes your acceptance of the updated Privacy Policy.
              </p>
            </div>

            {/* 16. Contact Us */}
            <div className="privacy-policy-item">
              <h3 className="privacy-policy-title">16. Contact Us</h3>
              <p>
                If you have questions, concerns, or requests regarding this Privacy Policy or our privacy practices, please contact us:
              </p>
              <p>
                <strong>Arch Elevators Pvt. Ltd.</strong> <br />
                <strong>Email:</strong> info@archelevators.com <br />
                <strong>Phone:</strong> +91 90332 26011 <br />
                <strong>Address:</strong> 305-4TH Floor, Silver Cross Building, Satellite, Ahmedabad 380015, India <br />
                <strong>Data Protection Officer:</strong> Available upon request
              </p>
            </div>

            {/* Last Updated */}
            <div className="privacy-policy-item" style={{ marginTop: "40px", borderTop: "1px solid #e0e0e0", paddingTop: "20px" }}>
              <p style={{ fontSize: "14px", color: "#666" }}>
                <strong>Last Updated:</strong> December 2025
              </p>
            </div>
          </div>
        </div>
      </section>
      {/*Privacy Policy Section End*/}

      {/*CTA Section*/}
      <CtaSection
        title="Questions About Privacy?"
        text="Contact us for more information"
        phoneNumber="+919033226011"
        breadcrumbsImg={bannerbg}
        shapeImageUrl={shapeImageUrl}
      />

      {/*Footer*/}
      <Footer />
    </React.Fragment>
  );
};

export default PrivacyPolicyMain;
